import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acdb065a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AutoInformation" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6 AutoInformation__problems"
}
const _hoisted_3 = { class: "problems__header" }
const _hoisted_4 = { class: "flex items-center text-red-400" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-lg" }, null, -1))
const _hoisted_6 = { class: "font-semibold text-red-400 ml-3" }
const _hoisted_7 = { class: "problems__body" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = {
  key: 1,
  class: "AutoInformation__header"
}
const _hoisted_10 = { class: "font-semibold" }
const _hoisted_11 = { class: "font-semibold text-sm" }
const _hoisted_12 = {
  key: 2,
  class: "AutoInformation__body"
}
const _hoisted_13 = { class: "body__row" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Общее количество штрафов", -1))
const _hoisted_15 = { class: "row__value" }
const _hoisted_16 = { class: "flex items-center justify-end mt-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.auto && _ctx.auto.details.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, "Имеются штрафы (" + _toDisplayString(_ctx.auto.details.length) + ")", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auto.details, (auto_detail, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "body__row",
                  key: `AutoDetail-${i}`
                }, [
                  _createElementVNode("p", _hoisted_8, "Статья: " + _toDisplayString(auto_detail.measure), 1),
                  _createElementVNode("p", null, "Номер административного штрафа: " + _toDisplayString(auto_detail.numAdministrative), 1),
                  _createElementVNode("p", null, "Дата комиссии: " + _toDisplayString(auto_detail.commissionDate), 1),
                  _createElementVNode("p", null, "Сумма штрафа: " + _toDisplayString(auto_detail.amount), 1),
                  _createElementVNode("p", null, "Орган власти: " + _toDisplayString(auto_detail.authority), 1),
                  _createElementVNode("p", null, " Статус штрафа: " + _toDisplayString(auto_detail.fineStatus ? 'Оплачен' : 'Не оплачен'), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.autoNumber || _ctx.autoTechnicalPassport)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.autoNumber), 1),
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.autoTechnicalPassport), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.auto)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.auto.total), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_the_button, {
        class: "red small mr-6",
        loading: _ctx.isDeclineLoading,
        disabled: !_ctx.isCanDecline || _ctx.isConfirmLoading,
        onClick: _ctx.onDecline
      }, {
        default: _withCtx(() => [
          _hoisted_17,
          _createTextVNode(" Отказать ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.isConfirmLoading,
        disabled: !_ctx.isCanConfirm || _ctx.isDeclineLoading,
        onClick: _ctx.onConfirm
      }, {
        default: _withCtx(() => [
          _hoisted_18,
          _createTextVNode(" Разрешить ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ])
  ]))
}